export const ConsumerPhoneValidationSectionViewUat = {
  resendCodeButton:
    'workflow.consumerPhoneValidation.validatePhoneNumber.resendCodeButton',
  editPhoneNumberButton:
    'workflow.consumerPhoneValidation.validatePhoneNumber.editPhoneNumberButton',
  title: 'workflow.consumerPhoneValidation.validatePhoneNumber.title',
}
